import { lazy, Suspense } from 'react';
import { Navigate, useLocation, useRoutes } from 'react-router-dom';
import LoadingScreen from './component/LoadingScreen';
import AuthGuard from './guards/AuthGuard';
import GuestGuard from './guards/GuestGuard';

const Loadable = (Component: any) => (props: any) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { pathname } = useLocation();
    return (
        <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
            <Component {...props} />
        </Suspense>
    );
};
const MainRouter = () => {

    return useRoutes([
        {
            path: '',
            element: <Navigate to={'/login'} replace />
        },
        {
            path: '*',
            element: <Navigate to={'/login'} replace />
        },
        {
            path: 'login',
            element: (
                <GuestGuard>
                    <Login />
                </GuestGuard>
            ),
        },
        {
            path: 'dashboard',
            element: (
                <AuthGuard>
                    <Dashboard />
                </AuthGuard>
            ),
        },
        {
            path: 'createBotFlow',
            element: (
                <AuthGuard>
                    <CreateBotFlow />
                </AuthGuard>
            ),
        },
        {
            path: 'botFlowView',
            element: (
                <AuthGuard>
                    <EditBotFlowView />
                </AuthGuard>
            ),
        },
        {
            path: '*',
            element: (
                <AuthGuard>
                    <NotFound />
                </AuthGuard>
            ),
        }
    ])

};
export default MainRouter;

const NotFound = Loadable(lazy(() => import('./page/ErrorPage/NotFound')));
const Login = Loadable(lazy(() => import('./page/Login/Login')));
const Dashboard = Loadable(lazy(() => import('./page/Dashboard/Dashboard')));
const CreateBotFlow = Loadable(lazy(() => import('./page/FlowPage/CreateBotFlow')));
const EditBotFlowView = Loadable(lazy(() => import('./page/FlowPage/EditBotFlowView')));
